import { useRecordContext } from "react-admin";
import { Student } from "../providers/studentsProvider";
import { Dialog, DialogContent, DialogTitle, DialogActions, TextField, Button } from "@mui/material";
import { useState } from "react";
import { DialogProps } from "../misc/DialogProps";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { LoadingButton } from "@mui/lab";

export function HubspotIdDialog(props: { dialogProps: DialogProps; closeDialog: () => void }) {
  const { dialogProps, closeDialog } = props;
  const student = useRecordContext<Student>();
  const [hubspotId, setHubspotId] = useState("");
  const [saving, setSaving] = useState(false);

  if (!student) {
    return null;
  }

  const handleSubmit = async () => {
    if (!hubspotId.trim()) {
      showErrorToast("Bitte geben Sie eine HubSpot Contact ID ein.");
      return;
    }

    setSaving(true);
    await runSafely(
      () =>
        dataProvider.update("students", {
          id: student.id,
          data: { hubspotContactId: hubspotId.trim() },
          previousData: student,
        }),
      {
        errorMessage: "Fehler beim Speichern der HubSpot Contact ID.",
        successMessage: "HubSpot Contact ID erfolgreich gespeichert.",
        onSuccess: () => {
          setSaving(false);
          setHubspotId("");
          closeDialog();
        },
        onError: () => {
          setSaving(false);
        },
      },
    );
  };

  const handleClose = () => {
    if (!saving) {
      setHubspotId("");
      closeDialog();
    }
  };

  return (
    <Dialog {...dialogProps} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>HubSpot Contact ID eingeben</DialogTitle>
      <DialogCloseButton onClick={handleClose} />
      <DialogContent sx={{ pt: 3, overflowY: "visible" }}>
        <TextField
          label="HubSpot Contact ID"
          value={hubspotId}
          onChange={(e) => setHubspotId(e.target.value)}
          placeholder="z.B. 123456789"
          fullWidth
          margin="normal"
          disabled={saving}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>
          Abbrechen
        </Button>
        <LoadingButton variant="contained" onClick={handleSubmit} disabled={!hubspotId.trim()} loading={saving}>
          Speichern
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
